import "../style/Spinner.css";

export function Spinner() {
  return (
    <div
      data-testid="spinner-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        height: "100vh"
      }}
    >
      <div className="sk-fading-circle" data-testid="spinner-fading-circle">
        <div
          className="sk-circle1 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle2 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle3 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle4 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle5 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle6 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle7 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle8 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle9 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle10 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle11 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
        <div
          className="sk-circle12 sk-circle"
          data-testid="spinner-segment"
          role="presentation"
        />
      </div>
    </div>
  );
}
